import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  href,
  className = ''
}: CTAButtonProps) {
  const classes = `inline-block bg-accent text-bg font-heading font-bold uppercase tracking-wider rounded-lg px-10 py-4 glow-green hover:glow-green-intense transition-all duration-300 text-center ${className}`;
  if (href) {
    return <motion.a whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.98
    }} href={href} target="_blank" rel="noopener noreferrer" className={classes} data-id="element-204">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={classes} data-id="element-205">
      {children}
    </motion.button>;
}